class MaterialesRecepcion {
    constructor({ id, detalles, user_name, proveedor_name, fk_user, fk_proveedor, num_pedido_proveedor, fecha_recepcion, estado, fk_pedido_proveedor, pp_fecha_enviado } = {}) {
        this.id = id
        this.fk_proveedor = fk_proveedor
        this.fk_user = fk_user
        this.fk_pedido_proveedor = fk_pedido_proveedor ?? null
        this.num_pedido_proveedor = num_pedido_proveedor
        this.fecha_recepcion = fecha_recepcion
        this.estado = estado ?? 'pendiente'
        this.detalles = detalles
        this.user_name = user_name
        this.proveedor_name = proveedor_name
        this.pp_fecha_enviado = pp_fecha_enviado ?? null
    }
}

export default MaterialesRecepcion